"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommand = exports.getEnvFromCommand = exports.defineReadonlyProperty = exports.utils = void 0;
var Common_1 = require("../BaseModule/Common");
exports.utils = new Common_1.Common;
var defineReadonlyProperty = function (target, propertyKey, propertyValue) {
    Object.defineProperty(target, propertyKey, {
        configurable: false,
        enumerable: true,
        value: propertyValue,
        writable: false
    });
};
exports.defineReadonlyProperty = defineReadonlyProperty;
var getEnvFromCommand = function (commandList) {
    var env = "Prod";
    if (commandList && commandList.length > 0) {
        for (var i = 0; i < commandList.length; i++) {
            var tmpCommand = commandList[i];
            var tmpMatch = tmpCommand.match(/^\-\-env\=([a-z0-9]{1,})$/i);
            if (tmpMatch) {
                env = tmpMatch[1];
            }
            else {
                var lMatch = tmpCommand.match(/^\-env\=([a-z0-9]{1,})$/i);
                if (lMatch) {
                    env = lMatch[1];
                }
            }
        }
    }
    return env;
};
exports.getEnvFromCommand = getEnvFromCommand;
var getCommand = function (command, cmdKey) {
    var result;
    var findKey = false;
    var findValue = false;
    var keyReg = /^[\-]{1,}/;
    var keyValueReg = /^([a-z0-9]{1,})\=/i;
    var isCmdKey = /^[\-]{1,}/.test(cmdKey);
    if (command && command.length > 0) {
        for (var i = 0; i < command.length; i++) {
            var cmd = command[i];
            if (isCmdKey) {
                if (cmd === cmdKey) {
                    if (!keyReg.test(command[i + 1])) {
                        result = command[i + 1] === undefined ? null : command[i + 1];
                        findValue = i + 1 < command.length;
                        break;
                    }
                }
            }
            else {
                if (!keyReg.test(cmd)) {
                    var keyMatchValue = cmd.match(keyValueReg);
                    if (keyMatchValue && keyMatchValue[1] === cmdKey) {
                        result = cmd.replace(keyValueReg, "");
                        findValue = true;
                        break;
                    }
                    else {
                        if (cmd === cmdKey && !keyReg.test(command[i - 1])) {
                            findKey = true;
                        }
                    }
                }
            }
        }
    }
    return findValue ? result : (findKey ? true : result);
};
exports.getCommand = getCommand;
